'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _IyvScorecard = require('./IyvScorecard.css');

var _IyvScorecard2 = _interopRequireDefault(_IyvScorecard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReportCardRow = (_dec = (0, _reactCssModules2.default)(_IyvScorecard2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ReportCardRow, _Component);

  function ReportCardRow(props) {
    (0, _classCallCheck3.default)(this, ReportCardRow);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ReportCardRow.__proto__ || (0, _getPrototypeOf2.default)(ReportCardRow)).call(this, props));

    _this.state = {
      data: props.data
    };
    return _this;
  }

  (0, _createClass3.default)(ReportCardRow, [{
    key: 'render',
    value: function render() {
      var data = this.state.data;


      return _react2.default.createElement(
        'div',
        { styleName: 'reportcard-result' },
        _react2.default.createElement(
          'div',
          { styleName: 'reportcard-title-wrap' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { styleName: 'reportcard-result-title' },
              data.title
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'reportcard-result-subtitle' },
              data.subtitle
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'reportcard-result-grade' },
          _react2.default.createElement(_components.Grade, {
            grade: data.rgrade,
            square: true
          })
        )
      );
    }
  }]);
  return ReportCardRow;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired
}, _temp)) || _class);
var IyvScorecard = (_dec2 = (0, _reactCssModules2.default)(_IyvScorecard2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvScorecard, _Component2);

  function IyvScorecard(props) {
    (0, _classCallCheck3.default)(this, IyvScorecard);
    return (0, _possibleConstructorReturn3.default)(this, (IyvScorecard.__proto__ || (0, _getPrototypeOf2.default)(IyvScorecard)).call(this, props));
  }

  (0, _createClass3.default)(IyvScorecard, [{
    key: 'render',
    value: function render() {
      // images
      var iyvLogoSrc = require('../../../static/images/iyv-logo-project-of-2021.jpg');
      var sriIcon = require('../../../static/images/sri.png');
      var ussifLogo = require('../../../static/images/ussif-icon.png');

      // objects and values
      var _props = this.props,
          fund = _props.fund,
          shareClass = _props.shareClass;
      var fund_id = shareClass.fund_id,
          investment_vehicle_id = shareClass.investment_vehicle_id;

      var ticker = shareClass.ticker ? shareClass.ticker : 'N';
      var hasSRIBadge = _convert2.default.boolean(fund.socially_responsible_fund);
      var hasUssifBadge = _convert2.default.float(shareClass.ussif) === 1.5;
      var name = _format2.default.sanitize(fund.fund_legal_name);
      var urlMid = name + '/' + ticker;
      var urlEnd = fund_id + '/' + investment_vehicle_id;

      // build a table dataset
      // label, title, figure, url
      var enviroFinData = [{
        title: 'Fossil fuels',
        siteTitle: 'Fossil Free Funds',
        subtitle: 'Coal/oil/gas energy, fossil-fired utilities, related financial companies',
        label: 'fossil',
        icon: 'bolt',
        rgrade: fund.grade_fossil,
        link: {
          url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-fuel-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil fuel investments'
        }
      },
      // {
      //   title: 'Fossil finance',
      //   siteTitle: 'Fossil Free Funds',
      //   subtitle: 'Investments in banks lending to fossil fuels',
      //   label: 'fossil-bank',
      //   icon: 'bolt',
      //   rgrade: fund.grade_fossil_bank,
      //   link: {
      //     url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-finance-insurance/' + urlEnd,
      //     title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil finance investments'
      //   }
      // },
      // {
      //   title: 'Fossil insurance',
      //   siteTitle: 'Fossil Free Funds',
      //   subtitle: 'Investments in insurance companies insuring fossil fuels',
      //   label: 'fossil-insure',
      //   icon: 'bolt',
      //   rgrade: fund.grade_fossil_insure,
      //   link: {
      //     url: 'https://fossilfreefunds.org/fund/' + urlMid + '/fossil-finance-insurance/' + urlEnd,
      //     title: fund.fund_legal_name + ' | Fossil Free Funds | Fossil insurance investments'
      //   }
      // },
      {
        title: 'Deforestation',
        siteTitle: 'Deforestation Free Funds',
        subtitle: 'Deforestation-risk agriculture, related financial companies, consumer brands',
        label: 'deforestation',
        icon: 'tree',
        rgrade: fund.grade_deforestation,
        link: {
          url: 'https://deforestationfreefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Deforestation Free Funds'
        }
      }];
      var socialFinData = [{
        title: 'Gender equality',
        siteTitle: 'Gender Equality Funds',
        subtitle: 'Gender equality scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_gender_equality,
        link: {
          url: 'https://genderequalityfunds.org/fund/' + urlMid + '/gender-lens-score/' + urlEnd,
          title: fund.fund_legal_name + ' | Gender Equality Funds'
        }
      }, {
        title: 'Diversity disclosures',
        siteTitle: 'Social Justice Funds',
        subtitle: 'Diversity disclosures scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_dei,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      }, {
        title: 'Racial justice',
        siteTitle: 'Social Justice Funds',
        subtitle: 'Racial justice scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_rji,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      }, {
        title: 'LGBTQ+ equity',
        siteTitle: 'Social Justice Funds',
        subtitle: 'LGBTQ+ equity scorecard group ranking',
        label: 'gender-equality',
        icon: 'balance-scale',
        rgrade: fund.grade_hrc,
        link: {
          url: 'https://socialjusticefunds.org/fund/' + urlMid + '/profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Social Justice Funds'
        }
      }, {
        title: 'Civilian firearms',
        siteTitle: 'Gun Free Funds',
        subtitle: 'Civilian firearms manufacturers, related gun retailers',
        label: 'firearms',
        icon: 'fighter-jet',
        rgrade: fund.grade_guns,
        link: {
          url: 'https://gunfreefunds.org/fund/' + urlMid + '/gun-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Gun Free Funds'
        }
      }, {
        title: 'Prison industrial complex',
        siteTitle: 'Prison Free Funds',
        subtitle: 'Prisons and borders industry, including private prison operators',
        label: 'prisons',
        icon: 'fighter-jet',
        rgrade: fund.grade_prison_industrial_complex,
        link: {
          url: 'https://prisonfreefunds.org/fund/' + urlMid + '/prison-industrial-complex-investments/' + urlEnd,
          title: fund.fund_legal_name + ' | Prison Free Funds'
        }
      }, {
        title: 'Military weapons',
        siteTitle: 'Weapon Free Funds',
        subtitle: 'Military arms manufacturers, including nuclear weapons, controversial weapons',
        label: 'weapons',
        icon: 'fighter-jet',
        rgrade: fund.grade_military,
        link: {
          url: 'https://weaponfreefunds.org/fund/' + urlMid + '/weapon-investments/' + urlEnd + '?screen=mil',
          title: fund.fund_legal_name + ' | Weapon Free Funds'
        }
      }, {
        title: 'Tobacco',
        siteTitle: 'Tobacco Free Funds',
        subtitle: 'Tobacco companies, and tobacco-promoting entertainment companies',
        label: 'tobacco',
        icon: 'ban',
        rgrade: fund.grade_tobacco,
        link: {
          url: 'https://tobaccofreefunds.org/fund/' + urlMid + '/tobacco-profile/' + urlEnd,
          title: fund.fund_legal_name + ' | Tobacco Free Funds'
        }
      }];

      // apply some conversion functions to the data
      var finDataConversions = function finDataConversions(finData) {
        for (var i = 0; i < finData.length; i++) {
          finData[i].grade = _format2.default.score(finData[i].rgrade);
          finData[i].sfgrade = finData[i].grade === 'N/A' ? 'NA' : finData[i].grade;
        }
        return finData;
      };
      enviroFinData = finDataConversions(enviroFinData);
      socialFinData = finDataConversions(socialFinData);

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'reportcard-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'reportcard-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'reportcard-content-gutter' },
            _react2.default.createElement(
              _components.Link,
              {
                to: _config2.default.links.aysinvest,
                title: 'Invest Your Values | As You Sow'
              },
              _react2.default.createElement('img', {
                src: iyvLogoSrc,
                alt: 'Invest Your Values',
                styleName: 'iyv-icon'
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'reportcard-title' },
              'Sustainability report card'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'reportcard-info' },
              'As You Sow\u2019s ',
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.links.aysinvest,
                  title: 'Invest Your Values | As You Sow',
                  xstrong: true
                },
                'Invest Your Values'
              ),
              ' report card grades mutual funds on environmental and social issues, including climate change, gender equality, and weapon investments. Click through to get more details on each issue.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'reportcard-info' },
              _react2.default.createElement(
                'strong',
                null,
                fund.fund_legal_name,
                '\xA0'
              ),
              shareClass.ticker ? _react2.default.createElement(
                'em',
                null,
                shareClass.ticker
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'reportcard-control-wrap' },
              hasUssifBadge ? _react2.default.createElement('img', {
                styleName: 'ussif',
                src: ussifLogo,
                alt: 'Member of USSIF',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-tip': '<div style=\'max-width:250px;\'>Member of The Forum ' + 'for Sustainable and Responsible Investment.</div>',
                'data-html': true,
                'data-place': 'bottom',
                'data-for': 'reportcard-ussif-tooltip'
              }) : null,
              hasSRIBadge ? _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'socially responsible',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-tip': '<div style=\'max-width:250px;\'>Reports a ' + 'Sustainability Mandate to Morningstar. ' + 'Sustainable funds consider issues like the ' + 'environment and human rights.</div>',
                'data-html': true,
                'data-place': 'bottom',
                'data-for': 'reportcard-sri-tooltip'
              }) : null,
              _react2.default.createElement(_reactTooltip2.default, { id: 'reportcard-sri-tooltip' }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'reportcard-ussif-tooltip' })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'reportcard-results' },
            _react2.default.createElement(
              'h3',
              { styleName: 'reportcard-section-header' },
              'Environment'
            ),
            enviroFinData.map(function (e, idx) {
              return _react2.default.createElement(
                'div',
                { key: 'iyv-result-' + idx },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: e.link.url,
                    title: e.link.title
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'reportcard-result-wrap ' + e.label + '-row' },
                    _react2.default.createElement(ReportCardRow, { data: e })
                  )
                )
              );
            }),
            _react2.default.createElement(
              'h3',
              { styleName: 'reportcard-section-header' },
              'Social'
            ),
            socialFinData.map(function (e, idx) {
              return _react2.default.createElement(
                'div',
                { key: 'iyv-result-' + idx },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: e.link.url,
                    title: e.link.title
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'reportcard-result-wrap ' + e.label + '-row' },
                    _react2.default.createElement(ReportCardRow, { data: e })
                  )
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'autocomplete-headline' },
            'Search more funds'
          ),
          _react2.default.createElement(_components.AutocompleteSearch, null)
        )
      );
    }
  }]);
  return IyvScorecard;
}(_react.Component), _class4.propTypes = {
  // from fund profile page container
  shareClass: _react.PropTypes.object.isRequired,
  fund: _react.PropTypes.object.isRequired
}, _temp2)) || _class3);
exports.default = IyvScorecard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvScorecard/IyvScorecard.js
// module id = 1389
// module chunks = 0